import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {useEffect, useState} from 'react';
import { GetInvitationById } from '../../../../../reduxToolkit/Invitation/InvitationApi';
import { STATUS_MODEL } from '../../../../../enums/statusEnum';
import routes from '../../../../../Routes/routes';
import {GetUserRestrictionVisitor} from '../../../../../reduxToolkit/Visitor/VisitorApi';
import {getUrlParameters} from "../Model/Model";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const RegistrationProcessApp = () => {

    const { id, guardFlowId } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { getInvitationById } = useSelector((state) => state.InvitationSlice);
    const  userRestriction  = useSelector((state) => state.VisitorSlice.getUserRestrictionVisitor);

    const [url, setUrl] = useState(null);
    const [documentUrl, setDocumentUrl] = useState(null);
    const [identityValidationDenied, setIdentityValidationDenied] = useState(false);
    const invitationId = getInvitationById?.invitation?.id;

    /**
     * retrieves data from the invitation
     */
    useEffect(() => {
        if (id && id !== invitationId) {
            dispatch(GetInvitationById(id));
        }
    }, [id, invitationId, dispatch]);

    useEffect(() => {
        if(!userRestriction) dispatch(GetUserRestrictionVisitor());
    }, []);

    /**
     * Access validation with statuses REJECTED and CANCELED.
     */
    useEffect(() => {
        const visitorStatusId = getInvitationById?.invitation?.visitorStatusId // invitation
        const statusId = getInvitationById?.invitation?.statusId // invitation
        const validation = [STATUS_MODEL.REJECTED, STATUS_MODEL.CANCELED]
        if (validation.includes(visitorStatusId) || statusId == STATUS_MODEL.CANCELED ) {
            navigate(routes.forbidden);
        }
    }, [getInvitationById]);


    useEffect(() => {
        const identityValidation = getInvitationById?.invitation?.identityValidation;
        if (userRestriction?.validationVisitor == false) {
            setUrl(null);
            return;
        }else if(identityValidation === STATUS_MODEL.DENIED){
            setIdentityValidationDenied(true);
            return;
        }
        let url;
        switch (identityValidation) {
            case STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION:
                url = getUrlParameters({url:routes.invitationDetails.identityValidation, id, guardFlowId})
                break;
            case STATUS_MODEL.PENDING_REVIEW:
                url = getUrlParameters({url:routes.invitationDetails.currentlyUnderReview, id, guardFlowId})
                break;
            case STATUS_MODEL.VALIDATED:
                url = getUrlParameters({url:routes.invitationDetails.successfullyVerified, id, guardFlowId})
                break;
            default:
                url = null;
        }
        setUrl(url);
    }, [getInvitationById, userRestriction, userRestriction?.validationVisitor, id]);

    useEffect(() => {
        if(!getInvitationById?.invitation) return;
        const documentStatusId = getInvitationById?.invitation?.statusId;

        let url;
        switch (documentStatusId) {
            case STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION:
            case STATUS_MODEL.CHANGES_REQUESTED:
                url = getUrlParameters({url:routes.invitationDetails.documentationValidation, id, guardFlowId})
                break;
            default:
                url =getUrlParameters({url:routes.invitationDetails.documentationUnderReview, id, guardFlowId})
        }
        setDocumentUrl(url);
    }, [getInvitationById]);

    return {
        id,
        guardFlowId,
        t,
        url,
        documentUrl,
        identityValidationDenied,
        navigate,
        dispatch,
        getInvitationById,
        userRestriction,
    }

}

export default RegistrationProcessApp
